import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgMapPinLine = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21.875 24.5h-5.41a29.124 29.124 0 0 0 2.566-2.598c3.003-3.453 4.594-7.093 4.594-10.527a9.625 9.625 0 0 0-19.25 0c0 3.434 1.587 7.074 4.594 10.527.8.919 1.657 1.787 2.566 2.598h-5.41a.875.875 0 0 0 0 1.75h15.75a.875.875 0 1 0 0-1.75ZM6.125 11.375a7.875 7.875 0 0 1 15.75 0c0 6.26-6.067 11.484-7.875 12.906-1.808-1.422-7.875-6.646-7.875-12.906Zm12.25 0a4.375 4.375 0 1 0-8.75 0 4.375 4.375 0 0 0 8.75 0Zm-7 0a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z" />
  </svg>
);
export default SvgMapPinLine;
